import {createPortal} from "react-dom";
import s from "./style.module.css";
import {Button, CircularProgress} from "@mui/material";
import React, {useEffect, useState} from "react";
import api from "../../../api/api";
import {toast} from "react-toastify";

const ModalReport = ({onClose, ageGroupId, disciplineId, disciplineStageId}) => {

    const [report, setReport] = useState([]);
    const [isShow, setIsShow] = useState(false);
    const [deletedId, setDeletedId] = useState(null);


    useEffect(() => {
        console.log(deletedId);

        console.log(ageGroupId);
        console.log(disciplineId);
        console.log(disciplineStageId);

        const getReports = async () => {
            setIsShow(true);
            const result = await api().get(`/reports/tpl2/${ageGroupId}/${disciplineId}/${disciplineStageId}`);
            if (result?.data.status === 'ok') {
                setReport(result.data.reports);
            }
            setIsShow(false);
        }
        getReports().then(() => {
        })
    }, []);

    const downloadReport = async (report_id, format, index) => {
        setDeletedId(index);

        const result = await api().post(`/reports/create2`, {
            report_id: report_id,
            age_group_id: ageGroupId,
            discipline_id: disciplineId,
            discipline_stage_id: disciplineStageId,
            format: format
        }, {
            responseType: 'arraybuffer',
        })
        if (!result.data) {
            toast.warning('Нет данных')
        } else {
            let type;
            let name;
            if (format === 'excel') {
                type = 'application/xlsx';
                name = 'отчет.xlsx';
            } else {
                type = 'application/pdf';
                name = 'отчет.pdf';
            }

            const blob = new Blob([result.data], {type: type});

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = name;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
        }

        setDeletedId(null);
    }

    const printReport = async (report_id, index) => {
        setDeletedId(index);

        try {
            const result = await api().post(
                `/reports/create2`,
                {
                    report_id: report_id,
                    age_group_id: ageGroupId,
                    discipline_id: disciplineId,
                    discipline_stage_id: disciplineStageId,
                    format: 'pdf',
                },
                {
                    responseType: 'arraybuffer',
                }
            );

            if (!result.data) {
                toast.warning('Нет данных для печати');
                setDeletedId(null);
                return;
            }

            const blob = new Blob([result.data], {type: 'application/pdf'});
            const url = window.URL.createObjectURL(blob);

            const printWindow = window.open(url);
            if (printWindow) {
                printWindow.onload = () => {
                    printWindow.print();
                    window.URL.revokeObjectURL(url);
                };
            } else {
                toast.error('Не удалось открыть окно для печати. Проверьте настройки браузера.');
            }
        } catch (error) {
            toast.error('Ошибка при формировании PDF для печати');
            console.error(error);
        }

        setDeletedId(null);
    };

    return createPortal(
        <div className={s.modal}>
            <div className={s.content}>
                <div className={s.header}>
                    <h3>Отчёты</h3>
                </div>

                {isShow &&
                    <div className={s.circular}>
                        <CircularProgress color="info" size={60}/>
                    </div>
                }

                {!isShow &&
                    <div
                        style={{
                            width: '950px',
                            maxHeight: '600px',
                            overflowY: 'auto',
                            padding: '10px',
                        }}
                    >
                        <div className={s.reports}>
                            {report?.map((el, index) => <div id={el.report_id} className={s.reports_item}>
                                {el.report_name}
                                <div className={s.button_block}>
                                    {deletedId !== (index + "" + 1) ?
                                        <Button id={index + "" + 1} variant="outlined" sx={{
                                            backgroundColor: '#fff',
                                            maxWidth: '25px',
                                            height: '25px',
                                            borderRadius: '10px',
                                            paddingTop: '7px'
                                        }} disabled={deletedId !== null} onClick={() => {
                                            downloadReport(el.report_id, 'pdf', index + "" + 1).then(r => {
                                            })
                                        }}>PDF</Button> :
                                        <div style={{width: '64px', height: '25px', textAlign: 'center'}}>
                                            <CircularProgress
                                                color="info" size={25}/></div>}
                                    {deletedId !== (index + "" + 2) ?
                                        <Button id={index + "" + 2} variant="outlined" sx={{
                                            backgroundColor: '#fff',
                                            maxWidth: '25px',
                                            height: '25px',
                                            borderRadius: '10px',
                                            paddingTop: '7px'
                                        }} disabled={deletedId !== null} onClick={() => {
                                            downloadReport(el.report_id, 'excel', index + "" + 2).then(r => {
                                            })
                                        }}>EXCEL</Button> :
                                        <div style={{width: '64px', height: '25px', textAlign: 'center'}}>
                                            <CircularProgress
                                                color="info" size={25}/></div>}
                                    {deletedId !== (index + "" + 3) ?
                                        <Button id={index + "" + 3} variant="outlined" sx={{
                                            backgroundColor: '#fff',
                                            height: '25px',
                                            maxWidth: '25px',
                                            borderRadius: '10px',
                                            paddingTop: '7px'
                                        }} disabled={deletedId !== null} onClick={() => {
                                            printReport(el.report_id, index + "" + 3).then(r => {
                                            })
                                        }}>PRINT</Button> :
                                        <div style={{width: '64px', height: '25px', textAlign: 'center'}}>
                                            <CircularProgress
                                                color="info" size={25}/></div>}
                                </div>
                            </div>)}
                        </div>
                    </div>
                }

                <div className={s.exit} onClick={onClose}>
                    <Button sx={{
                        height: '40px',
                        width: '110px'
                    }} variant="contained">Закрыть</Button>
                </div>
            </div>
        </div>
        , document.body);
}

export default ModalReport;